import React from 'react'
import { paymentType } from '@abroad/components'
import CardsListing from './CardsListing'

export const renderPlanPayment = (subscription) => {
  return (
    <>
      {/* added upfrontFee & subscriptionAmount if payment type is recurring */}
      {subscription?.upfrontFee >= 0 &&
      subscription?.subscriptionAmount >= 0 &&
      subscription?.paymentCycle === Object.values(paymentType)[0]
        ? subscription?.nextPaymentDate
          ? subscription?.nextChargeAmount >= 0 &&
            subscription?.nextChargeDate === subscription?.planStartDate
            ? `$${subscription?.upfrontFee + subscription?.subscriptionAmount}`
            : `$${subscription?.subscriptionAmount}`
          : subscription?.totalDurationOfContract > 1
          ? `$${subscription?.subscriptionAmount}`
          : `$${subscription?.upfrontFee + subscription?.subscriptionAmount}`
        : null}
      {/* added onetimeAmount if payment type is onetime */}
      {subscription?.onetimeAmount >= 0 &&
      subscription?.paymentCycle === Object.values(paymentType)[1]
        ? `$${subscription?.onetimeAmount}`
        : null}
    </>
  )
}

const CoachingPlanInformation = ({
  staticSOWData,
  subscription,
  selectedCardDetails,
  setSelectedCardDetails,
  onContinue,
  setShowSelectedCard,
}) => {
  return (
    <div className='mt-30px'>
      <div className='mb-4 payment-details'>
        <CardsListing
          selectedCardDetails={selectedCardDetails}
          setSelectedCardDetails={setSelectedCardDetails}
          enabledUncheckedAction={true}
          onContinue={onContinue}
          setShowSelectedCard={setShowSelectedCard}
        />
      </div>
    </div>
  )
}

export default CoachingPlanInformation
